import React, { FC } from "react";
import {
  LookupTypeEnum,
  SearchPanelPropsModel,
  SalesInGraphReportSearchParamsModel,
  LookupItemModel,
} from "../../../models";
import { Form } from "antd";
import { getLabelName } from "../../../utils";
import { useLookups } from "../../../hooks";
import {
  ButtonBox,
  PrivilegesChecker,
  SelectBox,
  InputDatePicker,
} from "../..";

export const ReportSalesInGraphSearchPanel: FC<
  SearchPanelPropsModel<SalesInGraphReportSearchParamsModel>
  // SearchPanelProps<ReportSalesInGraphSearchParamsString>
> = ({ setSearchParams, handelSearch, searchParams, setLoading, formId }) => {
  //#region state
  const { getLookupItems } = useLookups(setLoading, [LookupTypeEnum.Users]);
  //#endregion
  //#region html
  return (
    <>
      <Form onFinish={handelSearch}>
        <div className="row row-cols-1 row-cols-sm-1 row-cols-md-3 g-3 align-items-start">
          <div className="col">
            <Form.Item
              name="fromDate"
              rules={[{ required: true, message: getLabelName("required") }]}
            >
              <InputDatePicker
                selectedDate={searchParams.fromDate}
                isClearable
                InputLabel={"From Date"}
                className="form-control"
                selectsStart
                startDate={searchParams.fromDate}
                endDate={searchParams.toDate}
                onChange={(date) => {
                  const obj = { ...searchParams };
                  obj.fromDate = date === null ? undefined : date;
                  setSearchParams(obj);
                }}
              />
            </Form.Item>
          </div>
          <div className="col">
            <Form.Item
              name="toDate"
              rules={[{ required: true, message: getLabelName("required") }]}
            >
              <InputDatePicker
                selectedDate={searchParams.toDate}
                isClearable
                InputLabel={"To Date"}
                className="form-control"
                selectsEnd
                startDate={searchParams.fromDate}
                endDate={searchParams.toDate}
                minDate={searchParams.fromDate}
                onChange={(date) => {
                  const obj = { ...searchParams };
                  obj.toDate = date === null ? undefined : date;
                  setSearchParams(obj);
                }}
              />
            </Form.Item>
          </div>
          <div className="col">
            <SelectBox
              labelName="User"
              isSingleSelect={true}
              selectedValues={
                searchParams.userId ? [searchParams.userId.toString()] : [""]
              }
              source={getLookupItems(LookupTypeEnum.Users, true)}
              onStatusChange={(e: LookupItemModel) => {
                const obj: any = { ...searchParams };
                if (e == null) {
                  obj.userId = undefined;
                } else {
                  obj.userId =
                    e.value === "" || e.value === null
                      ? undefined
                      : parseInt(e.value);
                }
                setSearchParams(obj);
              }}
            />
          </div>
        </div>
        <PrivilegesChecker formId={formId} action="EnableSearch">
          <div className="d-flex justify-content-end mt-3">
            <ButtonBox
              iconType="magnify"
              className="btn-gradient-primary btn-fw"
              variant="outline-primary"
              type="submit"
            >
              {getLabelName("Search")}
            </ButtonBox>
          </div>
        </PrivilegesChecker>
      </Form>
      {/* </Card.Body>
      </Card> */}
    </>
  );
  //#endregion
};
